import { useNavigate } from 'react-router-dom';
import { ShoppingCart, FileText } from 'lucide-react';

import { Button, Modal } from './ui';

import styles from './NoCreditsModal.module.css';

const ACTION_SUFFIX: Record<string, string> = {
  simulation_official: 'para fazer este simulado',
  correction: 'para esta correção',
  exam_creation: 'para criar simulado',
  student_correction: 'para corrigir alunos',
};

export function buildNoCreditsSubtitle(actionType?: string): string {
  const base = 'Você não tem créditos suficientes';
  const suffix = actionType ? ACTION_SUFFIX[actionType] : undefined;
  if (suffix) return `${base} ${suffix}.`;
  return `${base} para essa ação.`;
}

interface Props {
  open: boolean;
  onClose: () => void;
  actionType?: string;
}

/**
 * Fase 3 — Modal global exibido quando o backend retorna 402 com
 * `INSUFFICIENT_CREDITS`, ou quando o frontend previne a ação por saldo
 * zero (ex.: clique em simulado no catálogo).
 *
 * Oferece dois caminhos: assinar um plano ou comprar pacote avulso.
 * Não fecha sozinho — usuário precisa agir ou dispensar.
 */
export default function NoCreditsModal({ open, onClose, actionType }: Props) {
  const navigate = useNavigate();
  const subtitle = buildNoCreditsSubtitle(actionType);

  const handleViewPlans = () => {
    onClose();
    navigate('/assinatura');
  };

  const handleBuyTopup = () => {
    onClose();
    navigate('/assinatura#topups');
  };

  return (
    <Modal isOpen={open} onClose={onClose} title="Saldo insuficiente" size="sm">
      <p className={styles.subtitle}>{subtitle}</p>
      <p className={styles.description}>
        Escolha um plano para liberar acesso contínuo ou compre um pacote avulso para essa ação.
      </p>
      <div className={styles.actions}>
        <Button variant="secondary" onClick={handleViewPlans}>
          <FileText size={16} aria-hidden />
          Ver planos
        </Button>
        <Button variant="primary" onClick={handleBuyTopup}>
          <ShoppingCart size={16} aria-hidden />
          Comprar pacote avulso
        </Button>
      </div>
    </Modal>
  );
}
